import {createStyles, makeStyles, Theme} from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    deleteButton: {
      marginTop: theme.spacing(2),
    },
  }),
);
